<!-- put-card -->
<template>
  <div class="put-way-list" v-if="show">
    <div class="put-way-title" v-if="showTitle">问卷投放至最精准人群</div>
    <div class="put-way-title put-way-title-h2" v-if="showTitleH2">{{title}}</div>
    <div class="put-way-con">
      <div class="put-way-item column-flex">
        <div class="title">投放到58App服务号</div>
        <div class="info">千万58用户帮您填写问卷</div>
        <div :class="['btn', { disabled: isPut }]" @click="put">
          {{ isPut ? "投放中..." : "一键投放" }}
        </div>
        <!-- 投放中 -->
        <div class="status">限时免费</div>
      </div>
      <div class="put-way-item column-flex">
        <div class="title">精准投放</div>
        <div class="info">样本选题，精准投放</div>
        <div class="btn disabled">即将上线</div>
        <div class="status">即将上线</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MSG } from "@/utils/utils";
import http from "@/utils/http";

export default {
  name: "put-way-list",
  data() {
    return {
      isPut: false,
      putObj: {},
    };
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
    showTitleH2: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(["shareSurvey"]),
  },
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    put() {
      if (this.isPut) {
        return;
      }
      this.isPut = true;
      http
        .post("/advertisingTask/save", { surveyId: this.shareSurvey.id })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.isPut = data;
            this.putObj[this.shareSurvey.id] = data;
            this.$emit("put");
          } else {
            MSG.error(message);
            this.isPut = false;
          }
        });
    },
    getPutStatus() {
      if (
        Object.prototype.hasOwnProperty.call(this.putObj, this.shareSurvey.id)
      ) {
        this.isPut = this.putObj[this.shareSurvey.id];
      } else {
        http
          .get("/advertisingTask/advertised", { surveyId: this.shareSurvey.id })
          .then((response) => {
            const { code, data, message } = response;
            if (code === 1) {
              this.isPut = data;
              this.putObj[this.shareSurvey.id] = data;
            } else {
              MSG.error(message);
            }
          });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.put-way-list {
  .put-way-title {
    height: 20px;
    font-weight: 400;
    line-height: 20px;
    width: 660px;
    margin: 0 auto 6px;
  }
  .put-way-title-h2{
    font-weight: 700;
    font-size: 18px;
    color: #181818;
    margin-bottom: 23px;
  }
  .put-way-con {
    display: flex;
    justify-content: center;
  }
  .put-way-item {
    position: relative;
    padding: 16px 30px;
    width: 320px;
    height: 132px;
    background-color: #fff8f7;
    border: 1px solid #ffe7e2;
    border-radius: 4px;
    .status {
      position: absolute;
      right: 0;
      top: 0;
      color: #fff;
      font-size: 12px;
      width: 68px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: linear-gradient(
        99.4deg,
        #ff962d 0%,
        #ff552d 75%,
        #ff552d 100%
      );
      border-radius: 0px 4px 0px 10px;
    }
    .title {
      margin-bottom: 3px;
      color: #333;
    }
    .info {
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      color: #999;
      margin-bottom: 18px;
    }
    .btn {
      background-color: #ff552d;
      color: #fff;
      height: 36px;
      line-height: 36px;
      border-radius: 2px;
      text-align: center;
      width: 100px;
      cursor: pointer;
      &.disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }
    }
  }
  .put-way-item + .put-way-item {
    margin-left: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shareCommon/put-card.vue